export default __webpack_public_path__ + "static/automator-63ac3c6fa0188f9c63d0684f5032b617.png";